import z from "zod";

export const projectRouterDataSchema = z.object({
  /** The path the page is served under, which the router hangs its own from. */
  basepath: z
    .string()
    .optional()
    // Trailing slash trimmed: the route generates the path with an optional
    // last segment, and the router matches its own base without one.
    .transform((value) => (value ?? "/project").replace(/\/+$/u, "") || "/"),

  /** Which kind the list holds; left out, it holds every project. */
  type: z
    .enum(["subscription", "intervention", "all"])
    .optional()
    .transform((value) => value ?? "all"),
});

export type ProjectRouterDataProps = z.infer<typeof projectRouterDataSchema>;
